export default __webpack_public_path__ + "static/media/iconAppleStore.03bd68fd.svg";